.btn-information{margin:10px 0 0 10px;padding:3px 9px}.pagination{margin:10px 0}
/*# sourceMappingURL=sms-text-templates-table.component-TUMBOJXS.css.map */
